/** Start Building, mobile create menu, nav, onboarding — trip/doc import entry tiles. */
export const TRIP_IMPORT_ENTRY_TITLE = 'Import from Docs';
export const TRIP_IMPORT_ENTRY_SUBTITLE =
  'AI pulls places from PDFs, Word & notes';
